import { AuthConstraintRoute } from '@sharelo-lib/auth';
import { useInitiationOnStoriesEditPageQuery } from '@sharelo-lib/data-access';
import { StoryEditorTemplate } from '@sharelo-lib/feature/story-editor-shared-ui';
import { ShareloSeo } from '@sharelo-lib/seo';
import { AppLoading } from '@sharelo-lib/ui';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React from 'react';

const StoryEditorTimelinesContainer = dynamic(
  () =>
    import('@sharelo-lib/feature/feature-story-timeline').then(
      (module) => module.StoryEditorTimelinesContainer,
    ),
  { ssr: false },
);

const StoryResponsesTimelinesPage = () => {
  const { t, ready } = useTranslation();
  const router = useRouter();
  const { initiationId } = router.query;

  const { loading, error, data } = useInitiationOnStoriesEditPageQuery({
    variables: {
      id: initiationId as string,
    },
  });

  if (loading || !data || !ready) {
    return <AppLoading />;
  }

  if (error) {
    return <p>{t('common.something_wrong')}</p>;
  }

  return (
    <AuthConstraintRoute>
      <ShareloSeo title={t('seo.title.edit-story') as string} />
      <StoryEditorTemplate storyId={initiationId as string}>
        <StoryEditorTimelinesContainer storyId={initiationId as string} />
      </StoryEditorTemplate>
    </AuthConstraintRoute>
  );
};

export default StoryResponsesTimelinesPage;
